import { generateClient, GraphQLResult } from "aws-amplify/api";
import { deleteImageRoute as deleteImageRouteGql } from "graphql/mutations";
import { ImageProcessingResult } from "utils/s3/handleToolboxResponse";

/**
 * Given the key of an image to delete and the user's auth token, call's the toolboxes deleteImage route
 * @author Eric Webb <ewebb@factorearth.com>
 * @param key The key for the image we want to delete
 * @param authToken The user's auth token
 * @returns The response from the toolbox
 */
async function deleteImageRoute(key: string): Promise<ImageProcessingResult> {
	interface QueryResponse {
		deleteImageRoute: ImageProcessingResult;
	}
	const client = generateClient({ authMode: "userPool" });
	const response = (await client.graphql({
		query: deleteImageRouteGql,
		authMode: "userPool",
		variables: {
			key,
		},
	})) as GraphQLResult<QueryResponse>;
	return response.data.deleteImageRoute;
}

export default deleteImageRoute;
